import Vector from "victor";
import { SingleOperation } from "./Operation";
import { Verb } from "../types/Verb";
import { HasTranslate, AttributeKey } from "../types/attributes";
import { WBEventUpsertSubjectAttributeSinglePayload } from "../types/WBEvent2";

export type TranslatableSubject = HasTranslate & {
  subjectID: string;
};

export class MoveOperation extends SingleOperation {
  subjects: TranslatableSubject[];

  constructor(delta: Vector, subjects: TranslatableSubject[]) {
    const backwardEvents: WBEventUpsertSubjectAttributeSinglePayload[] =
      subjects.map((s) => {
        return {
          verb: Verb.UpsertSubjectAttributeSingle,
          subjectID: s.subjectID,
          version: -1,
          attribute: { key: AttributeKey.Translate, value: s.translate },
        };
      });

    const forwardEvents: WBEventUpsertSubjectAttributeSinglePayload[] =
      subjects.map((s) => {
        const newTranslate = Vector.fromArray(s.translate).add(delta);
        return {
          verb: Verb.UpsertSubjectAttributeSingle,
          subjectID: s.subjectID,
          version: -1,
          attribute: {
            key: AttributeKey.Translate,
            value: [newTranslate.x, newTranslate.y],
          },
        };
      });

    super(forwardEvents, backwardEvents);
    this.subjects = subjects;
  }

  get label(): string {
    if (this.subjects.length == 1) {
      return `Move ${this.subjects.length} shapes`;
    } else {
      return `Move 1 shape`;
    }
  }
}
